export const country = function (item = null) {
    return {
        id: item == null ? null : item.id,
        name: item == null ? null : item.name,
        code: item == null ? null : item.code,
        currency: item == null ? null : item.currency,
        timezone: item == null ? null : item.timezone,
        urlId: item == null || item['@id'] == undefined ? '' : item['@id'],
        decimalDigits: item == null ? 0 : item.decimalDigits,
        isActive: item == null ? 0 : item.isActive,
        enabled: item == null ? 1 : item.enabled,
        deleted: item == null ? 0 : item.deleted,
        tva: item == null ? 0 : item.tva,
        stripe: item == null ? 0 : item.stripe
    };
};
